/**
 * Survey launcher factory for Web SDK
 */

import * as Api from "@ms-ofb/officefloodgatecore/dist/src/Api/Api";
import UISurvey from "./../FloodgateCore/UISurvey/UISurvey";
import * as Window from "./../Window/Window";

export default class AdaptiveSurveyLauncherFactory implements Api.ISurveyLauncherFactory {
	public makeSurveyLauncher(survey: Api.ISurvey): Api.ISurveyLauncher {
			return new RudeSurveyLauncher(survey);
	}
}

class RudeSurveyLauncher implements Api.ISurveyLauncher {
	private survey: Api.ISurvey;

	constructor(survey: Api.ISurvey) {
		this.survey = survey;
	}

	public launch(): void {
		Window.get().OfficeBrowserFeedback.floodgate.showSurvey(new UISurvey(this.survey));
	}
}
